export const selectBudgetCategories = (state: any) =>
  state.getBudgetCategories || [];
